import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../@types/filter";
import { Paginated } from "../../@types/paginated";
import { apisiseci } from "../api";
import { ServiceAvailable } from "../../@types/service-available";
import { useDefaultSearchParams } from "../../hooks/useSearchParams";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
  unidade?: string;
};

export function useServiceAvailableList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  return useQuery<Paginated<ServiceAvailable>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['service-available', 'list', params],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<ServiceAvailable>>(
        "/cms/servicos_disponiveis/",
        { headers: { Authorization: `Bearer ${token}` }, params }
      );
      return response.data;
    },
  });
}
